import { ChangeDetectionStrategy, Component, computed, input, signal } from '@angular/core';
import { UserApi } from 'api/user/user-api.js';
import { UserDb } from 'lib/cosmos/user/userDb.js';
import { FormSaveHandler } from 'lib/ui/form/form-save-button.component.js';
import { map } from 'rxjs';
import { CoreAppComponent } from 'src/app/core/core-app.component';

@Component({
    selector: 'mod-sign-up-form',
    templateUrl: './sign-up-form.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SignupFormComponent extends CoreAppComponent {
	public readonly useFullSize = input<boolean>(false);
	public readonly showFieldNames = input<boolean>(true);
	public readonly enablePasswordPreview = input<boolean>(true);

	public readonly form = {
		email: signal<string | undefined>(undefined),
		password: signal<string | undefined>(undefined)
	};

	public readonly saveHandler = computed<FormSaveHandler>(() => {
		const email = this.form.email();
		const password = this.form.password();

		if (!email || !password) {
			return undefined;
		}

		const formData: UserApi.INewUserRequest = {
			email: email,
			password: password,
			timezone: this.getCurrentTimezone(),
			referrer: document.referrer
		};

		return this.dependencies.httpService
			.post<UserDb.IAuthUserResponse, UserApi.INewUserRequest>((builder) =>
				builder.withCustomApiRoute('user', 'signup').withData(formData).build()
			)
			.pipe(
				map((response) => {
					this.dependencies.authService.login(response.data.token);
					this.dependencies.navigateService.trainerAccountReadyPage().navigate();
				})
			);
	});

	constructor() {
		super();
	}

	private getCurrentTimezone(): string {
		return this.dependencies.timeService.currentZone.name;
	}
}
